"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTransitionableSendable = exports.useTransitionableChips = exports.useTransitionable = void 0;
var _react = require("react");
var _core = require("@focaltec-suite/core");
var ALLOWED_FORWARD = ['PENDING_TO_AUTHORIZE', 'PENDING_ACCOUNTING', 'PENDING_TO_DEFINE', 'VALIDATION', 'RUNNING'];
var ALLOWED_BACKWARD = [].concat(ALLOWED_FORWARD, ['PENDING_TO_PAY', 'PENDING_TO_REFUND']);
var EMPTY = {
  allowedForward: false,
  allowedBackward: false
};
var useTransitionable = exports.useTransitionable = function useTransitionable(userId, roleIds, actions, overview) {
  var verifyOwner = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  var _a, _b, _c, _d, _e;
  var context = (0, _react.useContext)(_core.AppContext);
  var item = overview === null || overview === void 0 ? void 0 : overview.item;
  var owners = (_b = (_a = item === null || item === void 0 ? void 0 : item.transition) === null || _a === void 0 ? void 0 : _a.owners) !== null && _b !== void 0 ? _b : [];
  var authorizingGroupIds = (_c = overview === null || overview === void 0 ? void 0 : overview.authorizing_group_ids) !== null && _c !== void 0 ? _c : [];
  var allowedTransition = (0, _react.useMemo)(function () {
    return context.isGrantedAny(actions);
  }, [context, actions]);
  if (!allowedTransition) {
    // no tiene permisos
    return EMPTY;
  }
  if (verifyOwner && userId === (item === null || item === void 0 ? void 0 : item.user_id)) {
    // nadie puedo "auto autorizarse"
    return EMPTY;
  }
  if (owners.filter(function (el) {
    return el.individual === userId || el.individual && authorizingGroupIds.indexOf(el.individual) >= 0 || el.actor && roleIds.indexOf(el.actor) >= 0;
  }).length === 0) {
    // no forma parte de los owners
    return EMPTY;
  }
  var stageId = (_e = (_d = item === null || item === void 0 ? void 0 : item.transition) === null || _d === void 0 ? void 0 : _d.stage_id) !== null && _e !== void 0 ? _e : '';
  return {
    allowedForward: ALLOWED_FORWARD.indexOf(stageId) >= 0,
    allowedBackward: ALLOWED_BACKWARD.indexOf(stageId) >= 0
  };
};
var useTransitionableSendable = exports.useTransitionableSendable = function useTransitionableSendable(userId, transitionable, roleIds) {
  var allowOwnerInPendingToSend = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var _a;
  if (((_a = transitionable === null || transitionable === void 0 ? void 0 : transitionable.transition) === null || _a === void 0 ? void 0 : _a.stage_id) !== 'PENDING_TO_SEND') {
    return false;
  }
  if ((transitionable === null || transitionable === void 0 ? void 0 : transitionable.user_id) === userId) return true;
  return allowOwnerInPendingToSend && roleIds.indexOf('owner') !== -1;
};
var useTransitionableChips = exports.useTransitionableChips = function useTransitionableChips(stage, transition, expenseTemplate) {
  var _a;
  var etChip;
  var stageChip;
  if (expenseTemplate) {
    etChip = {
      text: expenseTemplate.name,
      color: 'success',
      variant: 'filled'
    };
  }
  var statusId = transition === null || transition === void 0 ? void 0 : transition.status;
  if (statusId && stage) {
    var status = stage.statuses.find(function (el) {
      return el.name === statusId;
    });
    stageChip = {
      text: (_a = status === null || status === void 0 ? void 0 : status.label) !== null && _a !== void 0 ? _a : statusId
    };
  }
  return [etChip, stageChip].filter(function (el) {
    return !!el;
  }).map(function (el) {
    return el;
  });
};